import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithPhoneNumber,
  signInWithPopup,
  GoogleAuthProvider,
  RecaptchaVerifier,
  type ConfirmationResult,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyABVEQRvsLTSBLCQapBGRQD_ZHnuFa_ch4",
  authDomain: "ramba-c4244.firebaseapp.com",
  projectId: "ramba-c4244",
  storageBucket: "ramba-c4244.firebasestorage.app",
  messagingSenderId: "299512582117",
  appId: "1:299512582117:web:74add35524e7d20943290c",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

let recaptchaVerifier: RecaptchaVerifier | null = null;

function getRecaptchaVerifier(): RecaptchaVerifier {
  if (recaptchaVerifier) {
    return recaptchaVerifier;
  }
  recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
    size: 'invisible',
  });
  return recaptchaVerifier;
}

export async function sendOTP(phone: string): Promise<ConfirmationResult> {
  const verifier = getRecaptchaVerifier();
  return signInWithPhoneNumber(auth, phone, verifier);
}

export async function confirmOTP(
  confirmation: ConfirmationResult,
  code: string,
): Promise<string> {
  const result = await confirmation.confirm(code);
  if (!result?.user) {
    throw new Error('Firebase confirmation succeeded but no user returned');
  }
  return result.user.getIdToken();
}

const googleProvider = new GoogleAuthProvider();

export async function signInWithGoogle(): Promise<string> {
  const result = await signInWithPopup(auth, googleProvider);
  if (!result?.user) {
    throw new Error('Google sign-in succeeded but no user returned');
  }
  return result.user.getIdToken();
}

export function resetRecaptcha() {
  if (recaptchaVerifier) {
    recaptchaVerifier.clear();
    recaptchaVerifier = null;
  }
}

export function mapFirebaseError(error: unknown): string {
  const code = (error as any)?.code || '';
  switch (code) {
    case 'auth/invalid-phone-number':
      return 'رقم الهاتف غير صالح';
    case 'auth/too-many-requests':
      return 'محاولات كثيرة. حاول مجدداً لاحقاً';
    case 'auth/network-request-failed':
      return 'خطأ في الشبكة - تحقق من اتصالك';
    case 'auth/invalid-verification-code':
      return 'رمز التحقق غير صحيح';
    case 'auth/session-expired':
    case 'auth/code-expired':
      return 'انتهت صلاحية الرمز. أعد الإرسال';
    default:
      return 'فشل التحقق. حاول مجدداً';
  }
}
